module.exports = __webpack_public_path__ + "bae8b6a53c867d254462872bbb72b031.svg";